// import * as mdb from 'mdb-ui-kit';
// import { MDCSelect } from '@material/select';
import simplebar from 'simplebar';
// import BootstrapTable from 'bootstrap-table';
// import select2 from 'select2';
import sidebar from './sidebar';
// import btable from './table';

export default { simplebar, sidebar };
